import type { AxiosError } from "axios";
import type {
  Opportunity,
  SaveOpportunitesFilterBody,
} from "~/app/sales/opportunities/types/common";

import { axios, getBackendApiErrorResponse } from "~/core/axios";
import type {
  BackendApiErrorResponse,
  BackendApiResponse,
} from "~/core/types/backend-api-response.type";

import type { OpportunityByObjectType, OpportunityViewType } from "./types";

export const createOpportunityFilterView = async (
  body: SaveOpportunitesFilterBody,
) => {
  try {
    const { data } = await axios.post<BackendApiResponse<OpportunityViewType>>(
      "/opportunities/filter-views",
      body,
    );
    return data.data;
  } catch (error) {
    const err = error as AxiosError<BackendApiErrorResponse>;
    console.log(err.response?.data);
    throw new Error(err.response?.data?.message || err.message);
  }
};

export const updateOpportunityView = async (
  body: SaveOpportunitesFilterBody,
) => {
  try {
    const { data } = await axios.patch<BackendApiResponse<OpportunityViewType>>(
      "/opportunities/filter-views",
      body,
    );
    return data.data;
  } catch (error) {
    const err = error as AxiosError<BackendApiErrorResponse>;
    console.log(err.response?.data);
    throw new Error(err.response?.data?.message || err.message);
  }
};

export const getOpportunitiesFilter = async (activePipeline: string) => {
  try {
    const { data } = await axios.get<BackendApiResponse<OpportunityViewType[]>>(
      "/opportunities/filter-views?pipeline_id=" + activePipeline,
    );
    return data.data;
  } catch (error) {
    const err = error as AxiosError<BackendApiErrorResponse>;
    console.log(err.response?.data);
    throw new Error(err.response?.data?.message || err.message);
  }
};

// TODO: Delete this function
export const deleteOpportunitiesFilter = async (filterViewId: string) => {
  try {
    const { data } = await axios.delete<BackendApiResponse<any>>(
      `/opportunities/filter-views/${filterViewId}`,
    );
    return data.data;
  } catch (error) {
    const err = error as AxiosError<BackendApiErrorResponse>;
    console.log(err.response?.data);
    throw new Error(err.response?.data?.message || err.message);
  }
};

export const getOpportunitiesByObject = async ({
  id,
  entityType,
}: {
  id: string;
  entityType: string;
}) => {
  try {
    const { data } = await axios.get<
      BackendApiResponse<OpportunityByObjectType[]>
    >(`/opportunities/object/${entityType}/${id}`);

    return data.data;
  } catch (error) {
    const err = getBackendApiErrorResponse(error);
    console.error(err.data);
    return [];
  }
};

export const getClientOpportunityById = async (
  opportunity_id: string,
  responseType: "page_based" | "attribute_based",
) => {
  if (opportunity_id.includes("mock")) return null;
  try {
    let url = `/opportunities/${opportunity_id}`;
    if (responseType === "attribute_based") {
      url += "/record-data";
    }
    const { data } = await axios.get<BackendApiResponse<Opportunity>>(url);

    return data.data;
  } catch (error) {
    const err = getBackendApiErrorResponse(error);
    console.log(err?.data);
    throw new Error(err?.data?.message || "Failed to get opportunity data");
  }
};
